export const defaultOpeningHoursValues = {
  startTime: '09:00',
  endTime: '17:00',
};
